import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularModule } from 'shared/modules/angular/angular.module';
import { ControlsModule } from 'shared/modules/controls/controls.module';
import { ListModule } from 'shared/modules/list/list.module';
import { MaterialModule } from 'shared/modules/material/material.module';
import { PipesModule } from 'shared/modules/pipes/pipes.module';
import { SkeletonModule } from 'shared/modules/skeleton/skeleton.module';
import { TypographyModule } from 'shared/modules/typography/typography.module';
import { DynamicFormComponent } from './dynamic-form.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { SubsetDialogComponent } from './subset-dialog/subset-dialog.component';
import { SubsetViewComponent } from './subset-view/subset-view.component';

@NgModule({
  declarations: [
    DynamicFormComponent,
    FileUploadComponent,
    SubsetViewComponent,
    SubsetDialogComponent,
  ],
  exports: [
    DynamicFormComponent,
    FileUploadComponent,
  ],
  imports: [
    TranslateModule,
    PipesModule,
    CommonModule,
    MaterialModule,
    AngularModule,
    ControlsModule,
    ListModule,
    SkeletonModule,
    TypographyModule,
  ],
})
export class DynamicFormModule {
}
